<template>
    <div>
        <el-scrollbar class="equipment_scroll">
            <div class="equipment_add_b_container">
                <div class="equipment_add_b">
                    <me-collapes @collapesCb="collapesCb" :treeTitle="'柜内设备选择'">
                        <div class="el-card1">
                            <div class="leader-title" style="margin-top: 20px">柜内设备选择</div>
                            <div class="tree-wrap">
                                <el-checkbox-group v-model="checkList" @change="leftChange">
                                    <el-checkbox
                                        v-for="checkItem in shebeiChecklist"
                                        :label="checkItem.tree_type_name"
                                        :key="checkItem.tree_type_id"
                                    >
                                        {{
                                            checkItem.tree_type_name
                                        }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </me-collapes>
                    <div class="right_container" :style="{ width: width }">
                        <div class="table-wrap-inner">
                            <el-table
                                :data="tableData"
                                class="leader-style-table leader-style-table-no"
                            >
                                <el-table-column prop="dlq_000006" label="所属配电柜"></el-table-column>
                                <el-table-column prop="pdbyq_000003" label="设备类型"></el-table-column>
                                <el-table-column prop="pdbyq_000001" label="设备名称"></el-table-column>
                                <el-table-column prop="bt_000003" label="数量">
                                    <template scope="scope">
                                        <el-input v-model="scope.row.bt_000003"></el-input>
                                        <!-- <span style="margin-left: 10px" v-else>{{ scope.row.countA || 0 }}</span> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <div slot="footer" class="dialog-footer footer">
            <el-button @click="onReset">取消</el-button>
            <el-button v-if="from == '1'" class="leader-common-button" @click="goPrevious">上一步</el-button>
            <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
    </div>
</template>
<script>
import * as api from '../../api/index';
import Collapes from '@/comon/components/collapse-block.vue';
export default {
    components: {
        'me-collapes': Collapes,
    },
    props: {
        from: String,
        firstStepData: Object,
        secondStepData: Object,
        shebeiChecklist: Object,
        currentTreeNode: Object,
        currentTreeTypeId: String,
    },
    data() {
        return {
            checkList: this.secondStepData ? this.secondStepData.checkList : [],
            width: '630px',
            tableData: this.secondStepData ? this.secondStepData.tableData : [],
            macChecklist: [],
            shebeiChecklist: this.shebeiChecklist,
        };
    },
    watch: {
        shebeiChecklist: {
            handler(newValue) {
                this.tableData = [];
                this.checkList = [];
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        onSubmit() {
            if (this.firstStepData) {
                const treeColumList = [];
                for (let key in this.firstStepData) {
                    treeColumList.push({
                        colum_id: key,
                        colum_value: this.firstStepData[key],
                    });
                }
                const param = {
                    p_tree_id: this.currentTreeNode.tree_id,
                    tree_level: this.currentTreeNode.tree_level,
                    tree_type_id: this.currentTreeTypeId,
                    treeColumList: treeColumList,
                    deviceList: this.genDeviceList(),
                };
                api.docInsert(param).then((res) => {
                    this.$emit('closeDialog', true);
                });
            } else {
                const param = {
                    tree_level: this.currentTreeNode.tree_level,
                    tree_id: this.currentTreeNode.tree_id,
                    tree_type_id: this.currentTreeNode.tree_type_id,
                    deviceList: this.genDeviceList(),
                };
                api.docInsert(param).then((res) => {
                    this.$emit('closeDialog', true);
                });
            }
        },
        genDeviceList() {
            const deviceList = [];
            this.checkList.forEach((item, index) => {
                this.shebeiChecklist.forEach((_item, _index) => {
                    if (item == _item.tree_type_name) {
                        const treeColumList = [];
                        this.tableData.forEach((data, ind) => {
                            if (item == data.pdbyq_000003) {
                                for (let key in data) {
                                    if (key == 'pdbyq_000003') {
                                        treeColumList.push({
                                            colum_id: key,
                                            colum_value: _item.tree_type_id,
                                        });
                                    } else {
                                        treeColumList.push({
                                            colum_id: key,
                                            colum_value: data[key],
                                        });
                                    }
                                }
                            }
                        });
                        const paramInner = {
                            tree_name: _item.tree_type_name,
                            tree_level: '40',
                            tree_type_id: _item.tree_type_id,
                            treeColumList: treeColumList,
                        };
                        deviceList.push(paramInner);
                    }
                });
            });
            return deviceList;
        },
        change(inject) {
            let rule = inject.rule;
            if (rule.length) {
                rule.forEach((item, index) => {
                    if (item.select == inject.self.field) {
                        this.rule[index].options = this[`options${index}`];
                    }
                });
                this.resetVal(inject.self.field, rule);
            }
        },
        resetVal(pId, arr) {
            for (const key in arr) {
                if (arr[key].select && arr[key].select == pId) {
                    let item = arr[key];
                    this.$set(item, 'value', '');
                    this.resetVal(arr[key].field, arr);
                }
            }
        },
        collapesCb(collapes) {
            this.width = collapes ? '630px' : '849px';
        },
        goPrevious() {
            this.$emit('changePage', {
                tableData: this.tableData,
                checkList: this.checkList,
            });
        },
        leftChange(checked) {
            const dataTemp = [];
            let countA = '1';
            checked.forEach((item, index) => {
                countA = '1';
                this.tableData.forEach((_item, _index) => {
                    if (_item.pdbyq_000003 == item) countA = _item.bt_000003;
                });
                dataTemp.push({
                    dlq_000006: this.currentTreeNode.tree_name.split('-')[0],
                    pdbyq_000003: item,
                    pdbyq_000001:
                        this.currentTreeNode.tree_name.split('-')[0] + item,
                    bt_000003: countA,
                });
            });
            this.tableData = dataTemp;
        },
        onReset() {
            this.$emit('closeDialog');
        },
    },
};
</script>
<style lang="scss">
.equipment_add_b_container {
    .equipment_add_b {
        display: flex;
        flex-direction: row;
        height: 500px;
        .collapes-block-container {
            height: auto !important;
        }
        .table-wrap-inner {
            background: none;
            padding: 0 !important;
        }
        .el-checkbox {
            width: 100%;
            color: #fff;
            margin: 5px 0 0 0;
        }
        .table-wrap-inner {
            height: 100%;
        }
        .el-input__inner {
            width: 100px;
            background: #fff;
            // color: #fff;
        }
    }
    .footer {
        text-align: center;
    }
    .leader-common-button {
        width: auto !important;
    }
    .leader-title {
        // @include font_color;
    }
}
</style>
